import makeStyles from "@mui/styles/makeStyles";
export const UnitAmenitiesStyles = makeStyles((theme) => ({
    root: {

        overflow: "hidden",

    },
    img: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px"
    },
    btn: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        fontSize:"0.875rem"
    },
    drawerHeaderStyle: {
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
    },
    drawerHeaderTextStyle: {
        fontSize:"1rem",
        fontWeight: "bolder",
        color: theme.typography.color.primary,
    },
}));